<template>
  <component
    :is="tag"
    class="fts-form-label"
    :class="[
      {'with-icon': icon},
      {'form-label--top': placement === 'top'},
      {'form-label--left': placement === 'left'},
      {'form-label--icon-right': iconRight},
      {'form-label--nowrap': !textWrap},
      {'form-label--comfort': comfortDesign},
      {'form-label--required': required},
      {'form-label--error': error},
      {'form-label--py': maintainLabelHeight}
    ]"
  >
    <!-- icon -->
    <div class="form-label__icon" v-if="icon || Boolean($slots.icon) || Boolean($scopedSlots.icon)">
      <slot name="icon">
        <i :class="icon"></i>
      </slot>
    </div>
    <!-- label -->
    <div class="form-label__label">
      <slot />
    </div>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'label'
    },
    icon: String,
    iconRight: Boolean,
    comfortDesign: Boolean,
    required: Boolean,
    error: Boolean,
    placement: String,
    textWrap: {
      type: Boolean,
      default: true
    },
    maintainLabelHeight: Boolean // work with form-control
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-form-label {
  display: flex;
	align-items: flex-start;
	font-family: $font-family;
	font-weight: 400;
  font-weight: var(--inistate-font-weight-light);
  font-size: var(--inistate-label-text-14);
  line-height: var(--inistate-paragraph-text-14--line-height);
	color: var(--fts-form-label);
  .form-label__icon {
    display: inline-flex;
    margin-right: 0.375rem;
    [class^="fts-icon-"],
    [class*=" fts-icon-"] {
      line-height: inherit;
    }
  }
  .form-label__label {
    width: inherit;
    word-break: normal;
    overflow-wrap: anywhere;
  }
  &.form-label--top {
    min-width: 0;
    margin-bottom: 0.375rem;
    &:not(.form-label--icon-right) {
      width: 100%;
    }
    & + .fts-form-helper {
      margin-top: -0.25rem;
    }
  }
  &.form-label--icon-right {
    flex-direction: row-reverse;
    justify-content: flex-end;
    .form-label__icon {
      margin-left: 0.375rem;
      margin-right: 0;
    }
  }
  &.form-label--left {
    @extend .form-label--icon-right;
    width: 180px;
    min-width: 180px;
    max-width: 180px;
    margin-right: 0.375rem;
    padding-left: 0.375rem;
    padding-right: 0.375rem;
    border-radius: $border-radius;
    .form-label__label {
      text-align: right;
    }
  }
  &.form-label--py {
    &.form-label--top {
      margin-bottom: 0;
    }
  }
  &.form-label--left,
  &.form-label--py {
    padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
  }
  &.form-label--required {
    .form-label__icon {
      color: var(--fts-danger);
    }
  }
  &.form-label--error {
    color: var(--fts-danger);
  }
  &.form-label--nowrap {
    .form-label__label {
      @include text-overflow-ellipsis;
    }
  }
}
</style>